
export class FilingTypes {
  static readonly Dac6MonthlyFiling = 'Dac6MonthlyFiling';
  static readonly Dac6QuarterlyFiling = 'Dac6QuarterlyFiling';
  static readonly Dac6YearlyFiling = 'Dac6YearlyFiling';
  static readonly Dac6OtherFiling = 'Dac6OtherFiling';
}

export enum FilingTypesEUEnum {
  Dac6MonthlyFiling = "Monthly Filing",
  Dac6QuarterlyFiling = "Quarterly Filing",
  Dac6YearlyFiling = "Yearly Filing",
  Dac6OtherFiling = "Other Filing",
  Dac6ThirdPartyFiling = "Third Party Filing"
}

export enum FilingTypesMexicoEnum {
  Dac6MonthlyFiling = "Monthly Filing",
  Dac6OtherFiling = "Other Filing",
  Dac6ThirdPartyFiling = "Third Party Filing"
}

